import React, { useEffect } from 'react'
import { ScrollView, Text, View } from 'react-native'
import HeaderWithBack from '../../components/Header/headerWithBack'
import { getCleanUrl } from '../../utils/Helper';
import { useCssStyle } from '../../customHook/getCssStyle';
import { ImageComp } from '../../components/Image/Image';
import { useTranslation } from 'react-i18next';
import { CMSPath } from '../../config/Constant';
import CustomPressable from '../../components/customPressable/customPressable';
import { CHEVRON_RIGHT } from '../../assets';

const SpaBooking0 = (props) => {
    const { currentWidget, bookingObj, updateBookingObj, handleNext, handleGoBack } = props;
    const getStyles = useCssStyle();
    const { t } = useTranslation();

    useEffect(()=>{

        if(bookingObj.spa_data){
            if (bookingObj?.spa_data?.length == 1) {
                handleNext(bookingObj.spa_data[0]?.spalocationId);
            } else if(currentWidget?.spaLocationId) {
                const selectedSpa = bookingObj.spa_data?.find(data => data.spalocationId == currentWidget.spaLocationId);
    
                if(selectedSpa)
                    handleNext(selectedSpa)
                // else
                //     setError(true);
            }
        }
        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bookingObj?.spa_data])



    const renderHeader = () => {
        return (
            <View style={getStyles(['widgetmainContainerHeaderContainer', 'spaBookingHeaderContainer'])} id='spaBookingHeaderContainer'>
                {
                    currentWidget?.widgetHeaderImageUrl && 
                        <ImageComp
                            source={getCleanUrl(currentWidget?.widgetHeaderImageUrl)} 
                            style={getStyles(['widgetmainContainerHeaderImg', 'spaBookingHeaderImg', 'spaBookingHeaderImg_spaBooking0'])} id={"spaBookingHeaderImg spaBookingHeaderImg_spaBooking0"}
                        />
                }
                <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'spaBookingHeaderTitleContainer'])} id='spaBookingHeaderTitleContainer'>
                    <Text style={getStyles(['widgetmainContainerHeaderTitle', 'spaBookingHeaderTitle'])} id='spaBookingHeaderTitle'>
                        {t("spaBooking.heading")}
                    </Text>
                </View>
            </View>
        )
    }
    
    return (
        <View style={getStyles(['widgetRootContainer', 'spaBookingRootContainer'])} id='spaBookingRootContainer'>
            <HeaderWithBack handleCustomBackPress={handleGoBack} />
            
            {bookingObj?.spa_data && <ScrollView
                automaticallyAdjustKeyboardInsets={true} 
                contentContainerStyle={getStyles(['widgetmainContainer', 'spaBookingMainContainer'])} 
                showsVerticalScrollIndicator={false}
                id='spaBookingMainContainer'
            >
                {renderHeader()}
                
                <View style={getStyles(['widgetmainContainerChildContainer', 'spaBookingMainContainerChildContainer'])} id='widgetmainContainerChildContainer spaBookingMainContainerChildContainer'>
                    {bookingObj?.spa_data?.map((iterator, index)=>{
                        if(!iterator.spaName && !iterator.spaDescription && !iterator.imageName) {
                            return <></>
                        }
                        let imagePath = iterator.imageName ? encodeURI(`${CMSPath}${iterator.imageName}`) : "";

                        return (
                            <CustomPressable
                                key={index}
                                style={getStyles(["list_itemContainer", "spaBookingItemContainer"])}
                                onPress={() => {
                                    handleNext(iterator?.spalocationId);
                                }}
                            >
                                {imagePath ? <ImageComp source={imagePath} style={getStyles(["list_itemContainer_image", 'spaBookingItemImg'])} id={"spaBookingItemImg"} /> : <></>}

                                <View style={getStyles(["list_itemContainer_textContainer", 'spaBookingItemTextContainer'])} id={"spaBookingItemTextContainer"} >
                                    {iterator.spaName && <Text style={getStyles(["list_itemContainer_textContainer_title", 'spaBookingItemTextName'])} id={"spaBookingItemTextName"} numberOfLines={2}>{iterator.spaName}</Text>}

                                    {iterator.spaDescription && <Text style={getStyles(["list_itemContainer_textContainer_subtitle", 'spaBookingItemTextDescription'])} id={"spaBookingItemTextDescription"} numberOfLines={2}>{iterator.spaDescription}</Text>}
                                </View>

                                <View id='list_itemContainer_arrow spaBookingItemArrow' style={getStyles(['list_itemContainer_arrow', 'spaBookingItemArrow'])}>
                                    <ImageComp source={CHEVRON_RIGHT} style={getStyles(['list_itemContainer_arrow_img'])}/>
                                </View>
                            </CustomPressable>
                        );
                    })}
                </View>

                 
            </ScrollView>}
        </View>
    )
}

export default SpaBooking0
